<template>
  <header
    role="banner"
    class="masthead"
    :class="{ 'masthead--hidden': !showNav }"
  >
    <slot></slot>
    <transition name="fade-overlay">
      <div
        class="masthead__overlay"
        v-show="showOverlay"
        @click.prevent="onOverlayClick"
      ></div>
    </transition>
  </header>
</template>

<script lang="js">
import {mapState} from "vuex";
export default {
  name: 'lms-masthead',
  data() {
    return {
      showNav: true,
      fixed: false,
      lastScrollPosition: 0,
      alertHeight: 0,
    }
  },
  computed: {
    ...mapState(['alertActive']),
    showOverlay() {
      return ((this.$breakpoint.mdAndDown && (this.$store.state.navOpen || this.$store.state.drawerOpen)) || (this.$store.state.drawerOpen || (this.$breakpoint.lgAndUp && this.$store.state.searchOpen)));
    },
    isAdmin() {
      return (document.body.classList.contains('admin-bar'));
    }
  },
  watch: {
    // when the alert is activated/deactivated,
    // compensate by changing the page's top padding
    alertActive() {
      this.$nextTick(() => {
        this.setPadding();
      });
    },
    // on mobile, when the overlay is shown, make sure it's top position
    // compensates for the presence of the alert
    showOverlay(newValue) {
      if(newValue) {
        this.$el.querySelector('.masthead__overlay').style.top = `${this.$el.offsetHeight}px`;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.setPadding);
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.setPadding);

    this.$nextTick(() => {
      setTimeout(() => {
        this.setPadding();
      }, 200);
    })

  },
  methods: {
    /**
     * Handle page scrolling and position masthead accordingly
     */
    handleScroll() {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop

      // Because of momentum scrolling on mobile, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return
      }
      // Stop executing if the difference between current scroll
      // position and last scroll position is less than the offset
      // if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 40) {
      //   return
      // }

      const direction = (currentScrollPosition < this.lastScrollPosition) ? 'up' : 'down';
      this.lastScrollPosition = currentScrollPosition
      // we have to compensate the top position for the WP admin bar if needed
      const zeroTop = (this.isAdmin) ? 32 : 0;

      // if we're scrolling up, but not yet to the bottom of the masthead
      if (direction === 'up' && currentScrollPosition > this.$el.offsetHeight) {
        // initially make sure it's completely off-screen
        this.$el.style.top = (zeroTop - this.topPosition()) + 'px';
        this.showNav = true;
        // if scrolling down and past the masthead
      } else if (direction === 'down' && currentScrollPosition >= this.$el.offsetHeight) {
        // this.fixed = false;
        this.$el.style.top = (zeroTop - this.$el.offsetHeight) + 'px';
        // we've scrolled up to within the height of the masthead
      } else if (currentScrollPosition < this.topPosition()) {
        this.$el.style.top = `${zeroTop}px`;
        this.showNav = true;
      } else {
        this.showNav = true;
      }
    },
    topPosition(px) {
      const position = (this.$store.state.alertActive) ? document.querySelector('.lms-alert').offsetHeight : 0;
      return (px) ? `${position}px` : position;
    },
    setPadding() {
      // const padding = (this.isAdmin) ? this.$el.offsetHeight + 32 : this.$el.offsetHeight;
      document.getElementById('app').style.paddingTop = `${this.$el.offsetHeight}px`;
    },
    /**
     * When clicked, hide the drawer and/or primary nav
     */
    onOverlayClick() {
      if (this.$store.state.drawerOpen) {
        this.$store.state.drawerOpen = false;
        this.$store.state.navOpen = false;
      } else if (this.$store.state.searchOpen) {
        this.$store.state.searchOpen = false;
      } else if (this.$store.state.navOpen) {
        this.$store.state.navOpen = false;
        this.$store.state.drawerOpen = false;
      }
    }
  },
}
</script>
